// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1614":"95202cf8","2660":"95202cf8","3184":"95202cf8","4261":"95202cf8","4263":"95202cf8","5760":"95202cf8","8005":"95202cf8","8598":"95202cf8","8756":"95202cf8"}[chunkId] + ".chunk.css";
};